import React from "react";
import { formatCurrency } from "../offerJoiningUtils";

const CONTRACT_STAMP = "/img/contract_stamp.png";

export const customFontFamily = {
  bold: "font-bold",
  normal: "font-normal",
  semibold: "font-semibold",
  boldFont: "font-bold",
  normalFont: "",
  italic: "italic",
};

export const config = {
  fontSizeXs: "text-xs",
  fontSizeSm: "text-[11px]",
  fontSizeBase: "text-[12px]",
  fontSizeLg: "text-[12.5px]",
  fontSizeTitle: "text-sm",
};

const SignatureBlock = ({ candidateName, joiningDateFormatted }) => (
  <div className={`grid grid-cols-2 gap-8 items-start ${config.fontSizeTitle} pt-4 my-4`}>
    <div className="flex flex-col items-start justify-start">
      <img src={CONTRACT_STAMP} alt="Authorized Signatory Stamp" className="h-[100px] object-contain object-left-top" />
    </div>

    <div className="text-left pl-6 flex flex-col gap-3 pt-1">
      <div className={`${customFontFamily.bold} text-gray-900`}>Accepted & Confirmed Above</div>
      <div className="flex items-center gap-2">
        <span className={customFontFamily.bold}>Signature:</span>
        <div className="border-b border-gray-400 flex-1 h-3"></div>
      </div>
      <div className="space-y-1">
        <div className="flex gap-2">
          <span className={customFontFamily.bold}>Name:</span>
          <span className={`uppercase ${customFontFamily.semibold}`}>{candidateName}</span>
        </div>
        <div className="flex gap-2">
          <span className={customFontFamily.bold}>Date:</span>
          <span>{joiningDateFormatted}</span>
        </div>
      </div>
    </div>
  </div>
);

const ContractOfferPDF = ({
  candidateName,
  candidateAddress,
  candidateMobile,
  candidateEmail,
  candidateLocation,
  position,
  offerRefCode,
  offerDateFormatted,
  joiningDateFormatted,
  cFeesM,
  cFeesY,
  cOtherM,
  cOtherY,
  cMobileM,
  cMobileY,
  cMedM,
  cMedY,
  cTotalM,
  cTotalY,
}) => {
  return (
    <div className={`bg-white text-gray-900 ${config.fontSizeLg} space-y-6`} style={{ fontFamily: "'Arial', 'Helvetica', sans-serif" }}>
      {/* PAGE 1 CONTENT */}
      <div className="space-y-4">
        <div className={`flex justify-between items-center ${customFontFamily.semibold} text-gray-800 ${config.fontSizeXs} mb-5 pb-1`}>
          <div>{offerRefCode}</div>
          <div>Date: {offerDateFormatted}</div>
        </div>

        <div className="space-y-0.5 text-gray-900">
          <div>To,</div>
          <div className={`${customFontFamily.bold} ${config.fontSizeTitle}`}>{candidateName},</div>
          {candidateAddress && <div>Address: {candidateAddress}</div>}
          {candidateMobile && <div>Mobile: {candidateMobile}</div>}
          {candidateEmail && <div>Email: {candidateEmail}</div>}
        </div>

        <div className={customFontFamily.semibold}>Dear {candidateName.split(" ")[0]},</div>

        <div className={`${customFontFamily.bold} text-gray-900 ${config.fontSizeTitle} underline`}>
          Sub: Contract Offer Letter with Contract Fees Break-up
        </div>

        <div className="space-y-3 text-justify leading-relaxed">
          <p>
            Referring to your application and the interview you attended with us, we are delighted to offer you the position of <span className={customFontFamily.bold}>"{position || "Sr. Inspection Engineer"}"</span> with DYC Global Private Limited, Thane.
          </p>

          <p>
            Please refer to the attached Contract Fees Break-up (CTC Annexure A) for details of your remuneration.
          </p>

          <p>
            You are required to report on your duties on or before <span className={customFontFamily.bold}>{joiningDateFormatted}</span>, at <span className={customFontFamily.bold}>9:30 am</span> and you shall be reporting to <span className={customFontFamily.bold}>Mr. Parag Wadekar</span>.
          </p>

          <div>
            <div className={`${customFontFamily.semibold} mb-1`}>Your place of reporting / work will be {candidateLocation || "Dahej, Gujarat"}.</div>
            <div className={`${customFontFamily.bold} pl-2 text-gray-900`}>
              TKIL Industries Pvt. Ltd. (formerly known as thyssenkrupp Industries India Pvt. Ltd.)<br />
              Dahej Shipyard, Jageshwar, Bharuch, Gujarat- 392130.
            </div>
          </div>

          <p>
            However, you may be required to work anywhere in India, if the company so directs, based on the exigencies of work.
          </p>

          <div>
            <div className={`${customFontFamily.semibold} mb-1.5`}>Please provide the following documents on or before the joining date:</div>
            <ul className="list-disc pl-5 space-y-1 text-gray-800">
              <li>2 Nos. Colour Passport Size Photograph with White Background.</li>
              <li>Proof of Salary drawn from previous employer. (Last 3 months' salary slips if applicable).</li>
              <li>Relieving Letters from last employer.</li>
              <li>Experience certificates from last employer.</li>
              <li>Self-attested PANCARD Copy.</li>
              <li>Aadhar Card copy or any other permanent address Proof & contact details.</li>
              <li>Copies of Credentials / Educational certificates / Testimonials.</li>
              <li>Professional Certification / Courses (NDT Test Certificates).</li>
            </ul>
          </div>
        </div>
      </div>

      <hr className="border-gray-200" />

      {/* PAGE 2 CONTENT */}
      <div className="space-y-3 text-justify leading-relaxed">
        <p>
          This contract offer will remain valid for 7 working days from the date of issuance. Please confirm your date of joining by signing and returning the attached Contract Fees Annexure A.
        </p>
        <p>
          In case of any delay, the company reserves the right to withdraw or cancel this Contract Offer.
        </p>
        <p>
          This contract offer is contingent upon successfully clearing the client interview (if required), receiving client approval, and completing a satisfactory reference check.
        </p>
        <p>
          The detailed Service Contract Letter will be issued within 7 working days of your joining.
        </p>
        <p>
          This contract will remain valid from your date of joining or until the completion of the client contract, whichever is earlier. Your services will be on a contractual basis, and the duration may be shortened, extended, or made transferable as per project or client requirements.
        </p>
        <p>
          We look forward to a long-term and mutually beneficial association.
        </p>

        <SignatureBlock candidateName={candidateName} joiningDateFormatted={joiningDateFormatted} />
      </div>

      <hr className="border-gray-200" />

      {/* PAGE 3 CONTENT */}
      <div>
        <div className={`space-y-0.5 ${customFontFamily.semibold} ${config.fontSizeXs} mb-2 text-gray-900`}>
          <div>Name: {candidateName}</div>
          <div>Location: {candidateLocation || "Dahej"}</div>
          <div>Designation: {position || "Sr. Inspection Engineer"}</div>
          <div>Department: Inspection Services</div>
          <div>Grade: E3</div>
        </div>

        <div className={`text-center ${customFontFamily.bold} ${config.fontSizeTitle} underline mb-2 text-gray-900 uppercase tracking-wide`}>
          CTC Annexure A – Contract Fees Break-up
        </div>

        <table className={`w-full border-collapse border border-gray-400 ${config.fontSizeXs} my-1`}>
          <thead>
            <tr className={`bg-gray-100 ${customFontFamily.bold} border-b border-gray-400 text-gray-900`}>
              <th className="border border-gray-400 px-3 py-1 align-middle text-left w-1/2">Monthly Allowances (A)</th>
              <th className="border border-gray-400 px-3 py-1 align-middle text-right w-1/4">Monthly (INR)</th>
              <th className="border border-gray-400 px-3 py-1 align-middle text-right w-1/4">Yearly (INR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-400 px-3 py-1 align-middle">Contract Fees</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cFeesM)}</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cFeesY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-1 align-middle">Other Allowances</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cOtherM)}</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cOtherY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-1 align-middle">Telephone/Mobile/R Connect Expense</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cMobileM)}</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cMobileY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-1 align-middle">Medical</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cMedM)}</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cMedY)}</td>
            </tr>
            <tr className={`${customFontFamily.bold} ${config.fontSizeXs} bg-gray-100 border-t-2 border-gray-400`}>
              <td className="border border-gray-400 px-3 py-1 align-middle">Total (Monthly)</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cTotalM)}</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(cTotalY)}</td>
            </tr>
          </tbody>
        </table>

        <div className="mt-3">
          <div className={`${customFontFamily.bold} underline mb-1 ${config.fontSizeXs}`}>Notes:</div>
          <ol className={`list-decimal pl-4 space-y-1.5 text-justify ${config.fontSizeSm} leading-relaxed text-gray-800`}>
            <li>The disbursement of the above components would depend upon the Service Rules.</li>
            <li>Medical Insurance: Up to amount declared above or insurance cover will be provided as per company policies for the same.</li>
            <li>All payments made under this agreement shall be subject to applicable statutory deductions as per prevailing laws. A deduction of 1% towards Tax Deducted at Source (TDS) shall be applicable, in accordance with the relevant regulations.</li>
            <li>Leaves: Leave entitlement will be governed by the prevailing HR policy / Leave Card.</li>
            <li>Contract Duration: This contract is initially for a period of 3 months and may be extended for a further period of 6 months based on performance and project requirements.</li>
            <li>Accommodation & Local Travel: Accommodation and local travel will be provided by the client.</li>
            <li>Food: Food arrangements will be managed by you.</li>
          </ol>
        </div>
      </div>

      <hr className="border-gray-200" />

      {/* PAGE 4 CONTENT */}
      <div className="space-y-3 text-justify leading-relaxed">
        <ol start="8" className={`list-decimal pl-4 space-y-2 text-justify ${config.fontSizeSm} leading-relaxed text-gray-800`}>
          <li>
            Mobilization & Demobilization Travel: The Company shall reimburse travel expenses incurred for mobilization and demobilization, in accordance with its prevailing policies.<br />
            For mobilization (joining), the employee may opt to travel by either train three tier or economy-class airfare. For demobilization (return), travel shall be undertaken by three tier train. All reimbursements will be processed upon submission of valid supporting documents and in line with company reimbursement guidelines.
          </li>
        </ol>

        <SignatureBlock candidateName={candidateName} joiningDateFormatted={joiningDateFormatted} />
      </div>
    </div>
  );
};

export default ContractOfferPDF;
